import React from 'react';

import { Box, Stack, Typography } from '@mui/material';

import type { ChecklistStatus, MarginBand } from '../utils';

interface Props {
  approvalType?: 'auto' | 'manual';
  band?: MarginBand;
  status: ChecklistStatus;
}

export default function ChecklistStatusDot({ approvalType = 'auto', band, status }: Props) {
  const colorKey = getStatusColor({ band, status });
  const label = getStatusLabel({ approvalType, band, status });

  return (
    <Stack
      direction="row"
      spacing={0.875}
      alignItems="center"
      sx={{ color: colorKey, fontWeight: 700, whiteSpace: 'nowrap' }}
    >
      <Box
        component="span"
        sx={{
          bgcolor: colorKey,
          borderRadius: '50%',
          boxShadow: '0 0 0 2px rgba(0,0,0,0.04)',
          height: 10,
          width: 10,
        }}
      />
      <Typography variant="body2" fontWeight={700}>
        {label}
      </Typography>
    </Stack>
  );
}

function capitalize(value: string) {
  return value.charAt(0).toUpperCase() + value.slice(1);
}

function getStatusColor({ band, status }: Pick<Props, 'band' | 'status'>) {
  if (band === 'red') {
    return 'error.main';
  }

  if (band === 'green' || status === 'approved') {
    return 'success.main';
  }

  return 'warning.main';
}

function getStatusLabel({ approvalType = 'auto', band, status }: Props) {
  if (status === 'approved') {
    return approvalType === 'manual' ? 'Manually approved' : 'Approved';
  }

  return band ? capitalize(band) : 'Requires approval';
}
